export const SET_FILTERS_PRODUCTS = 'SET_FILTERS_PRODUCTS';
export const SET_FILTERS_PRODUCTS_LOADER = 'SET_FILTERS_PRODUCTS_LOADER';